import { render, staticRenderFns } from "./MainBusinessPage.vue?vue&type=template&id=f858dd1e&scoped=true&"
import script from "./MainBusinessPage.vue?vue&type=script&lang=js&"
export * from "./MainBusinessPage.vue?vue&type=script&lang=js&"
import style0 from "./MainBusinessPage.vue?vue&type=style&index=0&id=f858dd1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f858dd1e",
  null
  
)

export default component.exports